var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_22780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.50034 0.00126404C2.98777 -0.0679948 0.0811777 2.71749 0.000976562 6.22981C0.0101417 8.01772 0.80182 9.71198 2.16742 10.866V12.7292C2.16742 12.8787 2.28868 13 2.43824 13C2.48899 13 2.53873 12.9857 2.58176 12.9588L4.09124 12.0159C4.86029 12.31 5.67695 12.46 6.50034 12.4584C10.0129 12.5276 12.9195 9.74216 12.9997 6.22984C12.9195 2.71749 10.0129 -0.0679948 6.50034 0.00126404Z",
    fill: "rgba(154, 154, 181, 1.00)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7783 4.44286C10.6977 4.33486 10.55 4.30254 10.4317 4.36703L7.61528 5.9025L5.86316 4.40006C5.75572 4.30795 5.59547 4.31407 5.49542 4.41415L2.24573 7.66383C2.1403 7.7699 2.14081 7.94138 2.2469 8.04681C2.33172 8.13113 2.46179 8.14981 2.56692 8.09279L5.3833 6.55731L7.13704 8.06029C7.24448 8.1524 7.40473 8.14628 7.50479 8.0462L10.7545 4.79652C10.8492 4.70093 10.8593 4.55031 10.7783 4.44286Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_22780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/Messenger.13d738bc77cea876e271a5918089fc1c.svg";
export { ForwardRef as ReactComponent };